export default "./images/survio-1vAQk-assets-rating_scale.png";